import Handlers, { HandlerOption } from 'types/Handlers'

// eslint-disable-next-line import/prefer-default-export
export const HANDLER_OPTIONS: HandlerOption[] = [
  { value: Handlers.THOMAS_JEFFERSON, label: 'Thomas Jefferson' },
  { value: Handlers.GEORGE_WASHINGTON, label: 'George Washington' },
  { value: Handlers.JAMES_MADISON, label: 'James Madison' },
  { value: Handlers.JAMES_MONROE, label: 'James Monroe' },
]
